import { useEffect, useRef } from "react";

type HasMessage = {
  message: string;
};

export function useLazyOnErrorCallback<T>(
  error: T extends HasMessage ? T | null : null,
  onError: (error: T) => void,
  nextAllowableCallTime: number,
) {
  const lastErrorMessage = useRef<string | null>(null);

  useEffect(() => {
    if (!error) {
      lastErrorMessage.current = null;
    } else if (error.message !== lastErrorMessage.current) {
      lastErrorMessage.current = error.message;
      if (Date.now() - nextAllowableCallTime > 0) {
        onError(error);
      }
    }
  }, [error, onError, nextAllowableCallTime]);
}
